export enum NotificationIconColors {
  WARNING = 'var(--warning)',
  DANGER = 'var(--error)',
}
